import { TextField } from "@mui/material";
import { STATE_LIST } from "../../utils/state-list";
import dayjs from "dayjs";
import { USER_ROLES } from "../../utils/constants";

const getUnitMachineStatusValue = (unitMachineStatus) =>
  typeof unitMachineStatus === "string"
    ? unitMachineStatus
    : unitMachineStatus?.value;

export const SOIL_CONDITION_DROPDOWN = [
  { label: "Soft Soil", value: "Soft Soil" },
  { label: "Hard Soil", value: "Hard Soil" },
  { label: "Black Soil", value: "Black Soil" },
  { label: "Red Soil", value: "Red Soil" },
  { label: "Laterite Soil", value: "Laterite Soil" },
  { label: "Arid Soil", value: "Arid Soil" },
  { label: "Peaty Soil", value: "Peaty Soil" },
];

export const UNIT_MACHINE_STATUS_DROPDOWN = [
  { label: "Sold to Customer", value: "Sold to Customer" },
  { label: "Depot Stock", value: "Depot Stock" },
  { label: "Dealer Stock", value: "Dealer Stock" },
];

export const getUnitMachineStatusForm = () => [
  { 
    name: "unitMachineStatus",
    type: "autocomplete",
    options: UNIT_MACHINE_STATUS_DROPDOWN,
    label: "Unit / Machine Current Status",
    placeholder: "Select status",
    required: true,
  },
];

export const getTicketFormRow1 = (oemNames, userDetails, oemList) => {
  const results = [
    {
      name: "oemName",
      type: "autocomplete",
      label: "OEM Name",
      options: oemNames,
      placeholder: "Enter oem name",
      required: true,
      disabled: true,
    },
    {
      name: "customerName",
      type: "text",
      label: "Customer Name",
      placeholder: "Enter customer name",
      required: true,
    },
    {
      name: "customerContact",
      type: "number",
      label: "Customer contact number",
      placeholder: "Enter customer number",
      required: true,
      validate: (value) =>
        `${value}`.length !== 10 ? "Contact Number Should be 10 digits" : null,
    },
    // {
    //   label: "OEM Engineer Name",
    //   name: "oemServiceEngineerName",
    //   placeholder: "Enter oem engineer number",
    //   type: "text",
    //   required: true,
    // },
    // {
    //   label: "OEM Engineer Contact",
    //   name: "oemServiceEngineerContact",
    //   placeholder: "Enter oem engineer contact",
    //   type: "number",
    //   required: true,
    //   validate: (value) =>
    //     `${value}`.length !== 10 ? "Contact Number Should be 10 digits" : null,
    // },
  ];
  if (userDetails?.admin) {
    results.push({
      label: "OEM Engineer Name",
      name: "oemServiceEngineerName",
      placeholder: "Enter oem engineer number",
      type: "autocomplete",
      required: true,
      options: oemList,
    });
    results.push({
      label: "OEM Engineer Contact",
      name: "oemServiceEngineerContact",
      placeholder: "Enter oem engineer contact",
      type: "number",
      required: true,
      validate: (value) =>
        `${value}`.length !== 10 ? "Contact Number Should be 10 digits" : null,
    });
  } else {
    results.push({
      label: "OEM Engineer Name",
      name: "oemServiceEngineerName",
      placeholder: "Enter oem engineer number",
      type: "text",
      required: true,
    });
    results.push({
      label: "OEM Engineer Contact",
      name: "oemServiceEngineerContact",
      placeholder: "Enter oem engineer contact",
      type: "number",
      required: true,
      validate: (value) =>
        `${value}`.length !== 10 ? "Contact Number Should be 10 digits" : null,
    });
  }
  return results;
};
export const getApplicationDropdown = (userDetails, oemNames = []) => {
  const { industry, role, oemNameId } = userDetails;
  const oemOrg = oemNames?.find((oem) => oem.id === oemNameId);
  if (role === USER_ROLES.ADMIN) {
    return [
      { label: "Mould board Plough", value: "Mould board Plough" },
      { label: "Seed Drill", value: "Seed Drill" },
      { label: "Tillers", value: "Tillers" },
      { label: "Rotavator 30 blades", value: "Rotavator 30 blades" },
      { label: "Rotavator 36 blades", value: "Rotavator 36 blades" },
      { label: "Rotavator 42 blades", value: "Rotavator 42 blades" },
      { label: "Rotavator 48 blades", value: "Rotavator 48 blades" },
      { label: "Rotavator 54 blades", value: "Rotavator 54 blades" },
      { label: "Baler", value: "Baler" },
      { label: "Mulcher", value: "Mulcher" },
      { label: "Trailer", value: "Trailer" },
      { label: "Harrow", value: "Harrow" },
      { label: "Sprayers", value: "Sprayers" },
      { label: "Harvesting", value: "Harvesting" },
      { label: "Disc Plough", value: "Disc Plough" },
      { label: "Leveler", value: "Leveler" },
      { label: "Straw Reaper", value: "Straw Reaper" },
      { label: "Seed drill", value: "Seed drill" },
      { label: "Subsoiler", value: "Subsoiler" },
      { label: "Cultivator 5 tyne", value: "Cultivator 5 tyne" },
      { label: "Cultivator 7 tyne", value: "Cultivator 7 tyne" },
      { label: "Cultivator 8 tyne", value: "Cultivator 8 tyne" },
      { label: "Cultivator 9 tyne", value: "Cultivator 9 tyne" },
      { label: "Cultivator 11 tyne", value: "Cultivator 11 tyne" },
      { label: "Haulage", value: "Haulage" },
      { label: "Disc harrow", value: "Disc harrow" },
      { label: "River bed operation", value: "River bed operation" },
      { label: "Digger", value: "Digger" },
      { label: "Power Harrow", value: "Power Harrow" },
      { label: "Potato Planter", value: "Potato Planter" },
      { label: "Powervator", value: "Powervator" },
      { label: "Loading & Unloading", value: "Loading & Unloading" },
      { label: "Lightening tower", value: "Lightening tower" },
      { label: "Lifting and Moving", value: "Lifting and Moving" },
      { label: "Road Construction", value: "Road Construction" },
      { label: "Excavating", value: "Excavating" },
      { label: "Digging", value: "Digging" },
      { label: "Trenching", value: "Trenching" },
      { label: "Welding Generator", value: "Welding Generator" },
      { label: "Stand by Genset", value: "Stand by Genset" },
      { label: "Prime Power Genset", value: "Prime Power Genset" },
      { label: "Marine", value: "Marine" },
      { label: "Others", value: "Others" },
      { label: "With out implementation / Load", value: "With out implementation / Load" },
    ];
  } else {
    if (oemOrg?.industry === "Agricultural") {
      return [
        { label: "Mould board Plough", value: "Mould board Plough" },
        { label: "Seed Drill", value: "Seed Drill" },
        { label: "Tillers", value: "Tillers" },
        { label: "Rotavator 30 blades", value: "Rotavator 30 blades" },
        { label: "Rotavator 36 blades", value: "Rotavator 36 blades" },
        { label: "Rotavator 42 blades", value: "Rotavator 42 blades" },
        { label: "Rotavator 48 blades", value: "Rotavator 48 blades" },
        { label: "Rotavator 54 blades", value: "Rotavator 54 blades" },
        { label: "Baler", value: "Baler" },
        { label: "Mulcher", value: "Mulcher" },
        { label: "Trailer", value: "Trailer" },
        { label: "Harrow", value: "Harrow" },
        { label: "Sprayers", value: "Sprayers" },
        { label: "Harvesting", value: "Harvesting" },
        { label: "Disc Plough", value: "Disc Plough" },
        { label: "Leveler", value: "Leveler" },
        { label: "Straw Reaper", value: "Straw Reaper" },
        { label: "Seed drill", value: "Seed drill" },
        { label: "Subsoiler", value: "Subsoiler" },
        { label: "Cultivator 5 tyne", value: "Cultivator 5 tyne" },
        { label: "Cultivator 7 tyne", value: "Cultivator 7 tyne" },
        { label: "Cultivator 8 tyne", value: "Cultivator 8 tyne" },
        { label: "Cultivator 9 tyne", value: "Cultivator 9 tyne" },
        { label: "Cultivator 11 tyne", value: "Cultivator 11 tyne" },
        { label: "Haulage", value: "Haulage" },
        { label: "Disc harrow", value: "Disc harrow" },
        { label: "River bed operation", value: "River bed operation" },
        { label: "Digger", value: "Digger" },
        { label: "Power Harrow", value: "Power Harrow" },
        { label: "Potato Planter", value: "Potato Planter" },
        { label: "Powervator", value: "Powervator" },
        { label: "With out implementation / Load", value: "With out implementation / Load" },
      ];
    } else if (oemOrg?.industry === "Industrial") {
      return [
        { label: "Loading & Unloading", value: "Loading & Unloading" },
        { label: "Lightening tower", value: "Lightening tower" },
        { label: "Lifting and Moving", value: "Lifting and Moving" },
        { label: "Road Construction", value: "Road Construction" },
        { label: "Excavating", value: "Excavating" },
        { label: "Digging", value: "Digging" },
        { label: "Trenching", value: "Trenching" },
        { label: "Welding Generator", value: "Welding Generator" },
      ];
    } else {
      return [
        { label: "Stand by Genset", value: "Stand by Genset" },
        { label: "Prime Power Genset", value: "Prime Power Genset" },
        { label: "Marine", value: "Marine" },
        { label: "Others", value: "Others" },
      ];
    }
  }
};
export const ADDRESS_FORM = [
  {
    name: "tractorAddress",
    type: "text",
    title: "Address",
    label: "Address",
    placeholder: "Enter address",
    required: true,
  },
  {
    name: "city",
    type: "text",
    label: "City",
    placeholder: "Enter City",
    required: true,
  },
  {
    name: "state",
    type: "autocomplete",
    options: STATE_LIST,
    label: "State",
    placeholder: "Select State",
    required: true,
  },
  {
    name: "pinCode",
    type: "text",
    label: "Pincode",
    placeholder: "Enter pincode",
    required: true,
  },
];
export const getTicketFormRow3 = (
  complaintCodes,
  userDetails,
  oemNames = [],
  isCqc = false,
  unitMachineStatus = null
) => {
  const statusValue = getUnitMachineStatusValue(unitMachineStatus);
  const isStockStatus =
    statusValue === "Depot Stock" || statusValue === "Dealer Stock";

  const results = [
    {
      name: "oemDealerName",
      type: "text",
      label: "OEM Dealer Name",
      placeholder: "Enter OEM Dealer Name",
      required: true,
    },
    // {
    //   name: "engineSerialNumber",
    //   type: "text",
    //   label: "Engine Serial Number",
    //   placeholder: "Enter Engine Serial Number",
    //   required: true,
    // },
    {
      name: "unitSerialNumber",
      type: "text",
      label: "Unit / Machine Serial Number",
      placeholder: "Enter Unit / Machine Serial Number",
      required: true,
    },
    {
      name: "dateOfSale",
      type: "datePicker",
      label: "Date of Sale / Installation of machine",
      placeholder: "Enter Date of Sale",
      required: true,
      maxDate: dayjs().startOf("day"),
      // disabled: isStockStatus,
    },
    {
      name: "customerComplaintDate",
      type: "datePicker",
      label: "Date of customer complaint",
      placeholder: "Enter Date of Sale",
      required: true,
      maxDate: dayjs().startOf("day"),
    },
    {
      name: "hmr",
      type: "number",
      label: "Hours of Operation",
      placeholder: "Hours of Operation",
      required: true,
    },
    {
      name: "customerRegularApplication",
      type: "autocomplete",
      options: getApplicationDropdown(userDetails, oemNames),
      label: "Operation / Application regularly used by customer",
      placeholder: "Operation / Application regularly used by customer",
      required: !isStockStatus,
      disabled: isStockStatus,
    },

    // {
    //   name: "cutInNumber",
    //   type: "text",
    //   label: "Cut In Number",
    //   placeholder: "Cut In Number",
    //   required: true,
    // },
  ];
  // const userOem = oemNames?.find((oem) => oem?.id === userDetails?.oemNameId);
  const isTafeOem =
    userDetails?.oemNameId === "d77558ca-f7ee-4836-94fc-75968cd499e6" ||
    userDetails?.oemNameId === "f017b5c7-3e6d-4c4b-837d-c20d46ef45e2";
  // userOem &&
  // (userOem?.name === "Tractors and Farm Equipments Ltd" ||
  //   userOem?.name?.includes("TAFE"));
  if (isTafeOem || isCqc) {
    results.push({
      name: "cqc",
      type: "text",
      label: "CQC",
      placeholder: "CQC",
      required: true,
    });
  }
  return results;
};
export const complaintCodeForm = (complaintCodes) => [
  {
    name: "natureOfCustomerComplaint",
    type: "autocomplete",
    options: complaintCodes,
    label: "Complaint Code",
    placeholder: "Complaint Code",
    required: true,
  },
];

export const descForm = (userDetails, oemNames = [], unitMachineStatus = null) => {
  const statusValue = getUnitMachineStatusValue(unitMachineStatus);
  const isStockStatus =
    statusValue === "Depot Stock" || statusValue === "Dealer Stock";

  return [
    {
      name: "investigationDetailsByOem",
      type: "textarea",
      label: "Details of Investigation carried out by OEM",
      placeholder: "Complaint Description",
      required: true,
    },
    {
      name: "actionTakenByOem",
      type: "textarea",
      label: "Action Taken by OEM",
      placeholder: "OEM Observations",
      required: true,
    },
    {
      name: "remarks",
      type: "textarea",
      label: "OEM Remarks",
      placeholder: "OEM Remarks",
      required: true,
    },

    {
      name: "applicationWhileComplaintObserved",
      type: "autocomplete",
      options: getApplicationDropdown(userDetails, oemNames),
      label: "Operation used while the complaint was observed",
      placeholder: "Operation used while the complaint was observed",
      required: true,
    },
    {
      name: "soilCondition",
      type: "autocomplete",
      options: SOIL_CONDITION_DROPDOWN,
      label: "Soil/Site condition",
      placeholder: "Soil/Site condition",
      required: !isStockStatus,
      disabled: isStockStatus,
    },
  ];
};

export const isFormValid = (ticketDetails, servicesList) => {
  let errors = {};
  if (!ticketDetails.soilCondition) {
    errors.soilCondition = true;
  }
  if (!ticketDetails.applicationWhileComplaintObserved) {
    errors.applicationWhileComplaintObserved = true;
  }
  if (!ticketDetails.customerRegularApplication) {
    errors.customerRegularApplication = true;
  }
  if (!ticketDetails.remarks) {
    errors.remarks = true;
  }
  if (!ticketDetails.investigationDetailsByOem) {
    errors.investigationDetailsByOem = true;
  }
  if (!ticketDetails.customerName) {
    errors.customerName = true;
  }
  if (!ticketDetails.oemName) {
    errors.oemName = true;
  }
  if (!ticketDetails.oemServiceEngineerName) {
    errors.oemServiceEngineerName = true;
  }

  if (!ticketDetails.oemServiceEngineerContact) {
    errors.oemServiceEngineerContact = true;
  }
  if (!ticketDetails.oemDealerName) {
    errors.oemDealerName = true;
  }
  if (!ticketDetails.engineSerialNumber) {
    errors.engineSerialNumber = true;
  }
  if (!ticketDetails.unitSerialNumber) {
    errors.unitSerialNumber = true;
  }
  if (!ticketDetails.dateOfSale) {
    errors.dateOfSale = true;
  }

  if (!ticketDetails.customerComplaintDate) {
    errors.customerComplaintDate = true;
  }
  if (!ticketDetails.hmr) {
    errors.hmr = true;
  }
  if (!ticketDetails.actionTakenByOem) {
    errors.actionTakenByOem = true;
  }

  if (!ticketDetails.natureOfCustomerComplaint) {
    errors.natureOfCustomerComplaint = true;
  }

  if (
    ticketDetails.hmr &&
    +ticketDetails.hmr > 100 &&
    servicesList &&
    servicesList.length === 0
  ) {
    errors.freeServicesErr = true;
  }

  return errors;
};

export const formatFreeServicesPayload = (services) => {
  const servicesObj = {
    firstService: getServiceObject(services, "firstService"),
    secondService: getServiceObject(services, "secondService"),
    thirdService: getServiceObject(services, "thirdService"),
    fourthService: getServiceObject(services, "fourthService"),
    fifthService: getServiceObject(services, "fifthService"),
    sixthService: getServiceObject(services, "sixthService"),
    seventhService: getServiceObject(services, "seventhService"),
  };
  Object.keys(servicesObj).forEach((key) => {
    if (Object.keys(servicesObj[key]).length === 0) {
      delete servicesObj[key];
    }
  });
  return servicesObj;
};

const getServiceObject = (services, type) => {
  let service =
    (services || []).find((s) => s && s.name && s.name.value === type) || {};
  if (service.name) {
    let se = JSON.parse(JSON.stringify(service));
    delete se.name;
    return se;
  }
  return service;
};

const SERVICE_LIST = [
  { label: "1st Service", value: "firstService" },
  { label: "2nd Service", value: "secondService" },
  { label: "3rd Service", value: "thirdService" },
  { label: "4th Service", value: "fourthService" },
];

export const convertFreeServiceObjectToArray = (services) => {
  let result = [];
  Object.keys(services).forEach((key) => {
    if (services[key].runningHours) {
      result.push({
        ...services[key],
        name: SERVICE_LIST.find((s) => s.value === key),
      });
    }
  });
};
export const FOC_FORM_COFIG1 = [
  {
    name: "oemName",
    type: "text",
    label: "OEM Name",
    placeholder: "Enter oem name",
    disabled: true,
  },
  {
    name: "dealerName",
    type: "text",
    label: "Dealer Name",
    placeholder: "Enter dealer name",
    required: true,
  },
  {
    name: "dealerCode",
    type: "text",
    label: "Dealer Code",
    placeholder: "Enter dealer code",
    required: true,
  },
];
export const FOC_FORM_CONFIG_ADDRESS = [
  {
    name: "line1",
    type: "text",
    label: "Address 1",
    placeholder: "Enter address",
  },
  {
    name: "line2",
    type: "text",
    label: "Address 2",
    placeholder: "Enter address",
  },
  {
    name: "line3",
    type: "text",
    label: "Address 3",
    placeholder: "Enter address",
  },
  {
    name: "city",
    type: "text",
    label: "City",
    placeholder: "Enter location",
    required: true,
  },
  {
    name: "state",
    type: "autocomplete",
    options: STATE_LIST,
    label: "State",
    placeholder: "Select State",
    required: true,
  },
  {
    name: "pinCode",
    type: "number",
    label: "Pincode",
    placeholder: "Enter pincode",
    required: true,
  },
];

export const FOC_FORM_COFIG3 = [
  {
    name: "machineSerailNumber",
    type: "text",
    label: "Machine Serial Number",
    placeholder: "Enter machine serial number",
    required: true,
  },
  {
    name: "installationDate",
    type: "datePicker",
    label: "Installation Date",
    required: true,
  },
  {
    name: "vehicleRegNumber",
    type: "text",
    label: "Vehicle Reg No.",
    placeholder: "Enter vehicle reg no.",
    required: true,
  },
  {
    name: "complaintDescription",
    type: "textarea",
    label: "Brief description of complaint",
    placeholder: "Description of complaint",
    required: true,
    fieldGridSize: 6,
  },
  {
    name: "investigationOnFailure",
    type: "textarea",
    label: "Investigation/ checks carried out on failure",
    placeholder: "Investigation on failure",
    required: true,
    fieldGridSize: 6,
  },
  {
    name: "detailsOfFailure",
    type: "textarea",
    label: "Details of present failure and findings",
    placeholder: "Details of present failure and findings",
    required: true,
    fieldGridSize: 12,
  },
];
export const SERVICE_TABLE_HEADERS = [
  {
    label: "Part No.",
    id: "partNumber",
    onClick: true,
    render: (data, onClick) => {
      return (
        <TextField
          size="small"
          variant="standard"
          onChange={(e) => onClick(data, "partNumber", e.target.value)}
          value={data?.partNumber}
        />
      );
    },
  },
  {
    label: "Description",
    id: "description",
    onClick: true,
    render: (data, onClick) => {
      return (
        <TextField
          size="small"
          variant="standard"
          onChange={(e) => onClick(data, "description", e.target.value)}
          value={data?.description}
        />
      );
    },
  },
  {
    label: "Qty",
    id: "qty",
    onClick: true,
    render: (data, onClick) => {
      return (
        <TextField
          size="small"
          variant="standard"
          type="number"
          onChange={(e) => onClick(data, "qty", e.target.value)}
          value={data?.qty}
        />
      );
    },
  },
];
export const FOC_FORM_CONFIG4 = (isAdmin = false) => {
  const result = [
    {
      name: "decisionRequestNumber",
      type: "text",
      label: "Decision Request No.",
      placeholder: "enter decision request no.",
      required: true,
    },
    {
      name: "engineModel",
      type: "text",
      label: "Engine Model",
      placeholder: "enter engine model",
      required: true,
      disabled: true,
    },
    {
      name: "engineSerialNumber",
      type: "text",
      label: "Engine Serial No.",
      placeholder: "enter engine serial no.",
      disabled: true,
    },
    {
      name: "failureDate",
      type: "datePicker",
      label: "Failure Date",
      required: true,
    },
    {
      name: "hoursOfFailure",
      type: "number",
      label: "Hours Of Failure",
      placeholder: "enter hours of failure",
    },

    {
      name: "dealerGstNumber",
      type: "text",
      label: "Dealer GST Number",
      placeholder: "enter dealer gst no.",
      required: true,
    },
    {
      name: "contactPersonName",
      type: "text",
      label: "Contact Person Name.",
      placeholder: "enter engine serial no.",
      required: true,
    },
    {
      name: "contactNo",
      type: "number",
      label: "Contact Number",
      placeholder: "contact number",
    },
    {
      name: "warrantyClaimNo",
      type: "text",
      label: "Warranty Claim No.",
      placeholder: "warranty claim no.",
      required: true,
    },
  ];
  if (isAdmin) {
    result.push({
      name: "date",
      type: "datePicker",
      label: "Date",
      disabled: true,
    });
  }
  return result;
};
export const convertedData = (inputData = {}) => {
  const data = Object.keys(inputData).map((key) => {
    const service = inputData[key];
    const serviceLabel = SERVICE_LIST.find((ele) => ele.value === key);
    return {
      name: {
        label: serviceLabel?.label,
        value: key,
      },
      date: service?.date?.split("T")[0], // Extract date (YYYY-MM-DD)
      runningHours: service.runningHours?.toString(), // Convert to string
      jobCardNumber: service.jobCardNumber,
    };
  });
  return data;
};

export const SERVICE_OBJECT = {
  firstService: 1,
  secondService: 2,
  thirdService: 3,
  fourthService: 4,
  fifthService: 5,
  sixthService: 6,
  seventhService: 7,
};
